import Instance from "../../../Axios";

// New Actions for the app

const DeletePartnerById = (id) => async (dispatch) => {
  await Instance()
    .put(`/plus/adesoes/partners/delete/${id}`)
    .then(({ data }) => {
      dispatch({ type: "DELETE_PARTNER_BY_ID", payload: data });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default DeletePartnerById;
